<div class="app">
    <div class="app__header">
        <ng-content select="[header]"></ng-content>
    </div>

    <div class="app__body">
        <ng-content select="[body]"></ng-content>
    </div>
</div>
